import { discriminatedUnion, enum as zodEnum, literal, object, string, type output } from 'zod';
import { disqualifyReasons } from '../nomination-scrubbing-status';

export const disqualifyReasonSchema = zodEnum(disqualifyReasons);

const standardDisqualificationRequestSchema = object({
  disqualifyReason: disqualifyReasonSchema.exclude(['Other']),
  feedback: string().optional(),
});

const otherDisqualificationRequestSchema = object({
  disqualifyReason: literal('Other'),
  feedback: string({
    error: 'Enter a reason for the disqualification.',
  }).min(1, 'Enter a reason for the disqualification.'),
});

export const disqualificationRequestSchema = discriminatedUnion('disqualifyReason', [
  standardDisqualificationRequestSchema,
  otherDisqualificationRequestSchema,
]);

export type DisqualificationRequest = output<typeof disqualificationRequestSchema>;
